(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daylilt-cinematic"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('daylilt-scene')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const scenes = new Set();
  let paused = false;
  let ticking = false;
  try { paused = localStorage.getItem('daylilt-motion-paused') === 'true'; } catch (error) {}
  const canMove = () => !paused && !reduced.matches && document.body.dataset.dlMotion !== 'false' && !window.Shopify?.designMode;
  const canPlay = () => canMove() && !navigator.connection?.saveData && !document.hidden;
  const updateButtons = () => {
    document.body.dataset.dlPaused = String(!canMove());
    document.querySelectorAll('[data-dl-toggle]').forEach(button => {
      button.hidden = reduced.matches || document.body.dataset.dlMotion === 'false' || !!window.Shopify?.designMode;
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-dl-toggle-label]').textContent = paused ? button.dataset.play : button.dataset.pause;
      button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
    });
  };
  const queue = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; scenes.forEach(scene => { if (scene.visible) scene.update(); }); });
  };
  class DayliltScene extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.visible = true;
      this.revealed = new WeakSet();
      this.motionAnimations = new Set();
      this.parallax = [...this.querySelectorAll('[data-dl-parallax]')];
      this.chapters = [...this.querySelectorAll('[data-dl-chapter]')];
      this.frames = [...this.querySelectorAll('[data-dl-frame]')];
      this.dots = [...this.querySelectorAll('[data-dl-dot]')];
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach(video => video.addEventListener('playing', () => video.classList.add('dl-video-playing'), {signal:this.abort.signal}));
      scenes.add(this);
      this.classList.add('dl-initialized');
      this.querySelectorAll('[data-dl-toggle]').forEach(button => button.addEventListener('click', () => {
        paused = !paused;
        try { localStorage.setItem('daylilt-motion-paused', String(paused)); } catch (error) {}
        syncMotion();
      }, {signal:this.abort.signal}));
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) { this.classList.toggle('dl-motion-running', canMove()); this.update(); }
          else this.classList.remove('dl-motion-running');
          this.syncVideo();
        }, {rootMargin:'80px 0px'});
        this.visibilityObserver.observe(this);
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.reveal(entry.target);
            this.revealObserver.unobserve(entry.target);
          });
        }, {threshold:0.12});
        this.querySelectorAll('[data-dl-reveal]').forEach((node,index) => { node.dataset.dlDelay = String((index % 3) * 70); this.revealObserver.observe(node); });
      }
      if (window.Shopify?.designMode) this.classList.add('dl-editor-mode');
      updateButtons();
      this.update();
    }
    reveal(node) {
      if (!canMove() || this.revealed.has(node) || typeof node.animate !== 'function') return;
      this.revealed.add(node);
      const animation = node.animate([{opacity:0.28,transform:'translate3d(0,26px,0)'},{opacity:1,transform:'translate3d(0,0,0)'}], {duration:950,delay:Number(node.dataset.dlDelay || 0),easing:'cubic-bezier(.2,.7,.2,1)',fill:'none'});
      this.motionAnimations.add(animation);
      animation.onfinish = () => this.motionAnimations.delete(animation);
    }
    update() {
      if (!document.hidden && canMove() && !mobile.matches) {
        const top = this.getBoundingClientRect().top;
        this.parallax.forEach(node => node.style.transform = `translate3d(0,${Math.max(-36,Math.min(36,-top*Number(node.dataset.dlParallax)))}px,0)`);
      } else this.parallax.forEach(node => node.style.removeProperty('transform'));
      if (!this.chapters.length || mobile.matches) return;
      let active = 0;
      const line = innerHeight * .62;
      this.chapters.forEach((chapter,index) => { if (chapter.getBoundingClientRect().top < line) active = index; });
      this.setChapter(active);
    }
    setChapter(index) {
      this.frames.forEach((frame,i) => frame.classList.toggle('is-active', i === index));
      this.dots.forEach((dot,i) => dot.classList.toggle('is-active', i === index));
    }
    syncVideo() {
      this.videos.forEach(video => {
        if (this.visible && canPlay()) { const play = video.play(); if (play) play.catch(() => {}); }
        else video.pause();
      });
    }
    sync() {
      this.classList.toggle('dl-motion-running', this.visible && canMove());
      if (!canMove()) { this.motionAnimations.forEach(animation => animation.cancel()); this.motionAnimations.clear(); }
      this.syncVideo();
      this.update();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.visibilityObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.motionAnimations.forEach(animation => animation.cancel());
      this.videos.forEach(video => video.pause());
      scenes.delete(this);
    }
  }
  function syncMotion() { updateButtons(); scenes.forEach(scene => scene.sync()); }
  customElements.define('daylilt-scene', DayliltScene);
  window.addEventListener('scroll', queue, {passive:true});
  window.addEventListener('resize', queue, {passive:true});
  reduced.addEventListener('change', syncMotion);
  mobile.addEventListener('change', syncMotion);
  document.addEventListener('visibilitychange', syncMotion);
  document.addEventListener('shopify:section:load', syncMotion);
  document.addEventListener('shopify:block:select', event => {
    const chapter = event.target.closest('[data-dl-chapter]');
    if (chapter) chapter.closest('daylilt-scene')?.setChapter(Number(chapter.dataset.dlChapter));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
